import { render, staticRenderFns } from "./MinimizedDescription.vue?vue&type=template&id=0ab6a34d&scoped=true"
import script from "./MinimizedDescription.vue?vue&type=script&lang=js"
export * from "./MinimizedDescription.vue?vue&type=script&lang=js"
import style0 from "./MinimizedDescription.vue?vue&type=style&index=0&id=0ab6a34d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab6a34d",
  null
  
)

export default component.exports